var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "new-journal",
    staticStyle: {
      "position": "relative"
    }
  }, [_vm.pageLoaded ? [_c('Header', {
    attrs: {
      "hasHeaderLine": _vm.hasHeaderLine
    }
  }), _c('currencies'), [_vm.articles.special ? _c('div', {
    attrs: {
      "id": "feed"
    }
  }, [_c('div', {
    staticClass: "slide-header row"
  }, [_c('slick', {
    ref: "slickMainSlider",
    attrs: {
      "options": _vm.slickOptionsMainSlider
    }
  }, _vm._l(_vm.articles.special, function (article) {
    return _c('a', {
      key: 'article-special-' + article.id,
      staticClass: "main-slide-container",
      attrs: {
        "href": article.url
      }
    }, [_c('div', {
      staticClass: "hero-container"
    }, [_c('div', {
      staticClass: "hero heroimg",
      style: {
        'background-image': 'url(\'' + article.image + '\')'
      }
    }), _c('div', {
      staticClass: "hero-inside title"
    }, [_c('div', {
      staticClass: "hero-inside-text"
    }, [_c('small', {
      staticClass: "label_backgorund"
    }, [_vm._v(_vm._s(article.categoryData.name))]), article.card_name ? _vm._l(article.card_name.split('<br>'), function (nameChunk) {
      return _c('div', {
        key: 'slider-article-name-chunk_' + nameChunk,
        staticClass: "h1 label_backgorund_white",
        domProps: {
          "innerHTML": _vm._s(nameChunk)
        }
      });
    }) : _c('div', {
      staticClass: "h1 label_backgorund_white"
    }, [_vm._v(_vm._s(article.name))])], 2)])])]);
  }), 0)], 1)]) : _vm._e()], !_vm.category && !_vm.isJournal ? [_vm.articles.desktop ? _c('div', {
    staticClass: "container pc"
  }, [_c('cards-section', {
    attrs: {
      "title": "Лайфхаки",
      "code": "life-hacks",
      "items": _vm.articles.desktop.lifeHacks,
      "link": "/category/lifehacks"
    }
  }), _c('cards-section', {
    attrs: {
      "title": "Знания",
      "code": "knowledge",
      "items": _vm.articles.desktop.knowledge,
      "link": "/category/knowledge"
    }
  }), _c('cards-section', {
    attrs: {
      "title": "Тесты",
      "code": "tests",
      "items": _vm.articles.desktop.test,
      "link": "/category/test"
    }
  }), _c('InvestBanner'), _vm.articles.desktop ? _c('cards-section', {
    attrs: {
      "title": "Ревью",
      "code": "reviews",
      "items": _vm.articles.desktop.reviews,
      "link": "/category/reviews"
    }
  }) : _vm._e()], 1) : _vm._e(), _c('div', {
    staticClass: "container phone new-main-feed"
  }, [_c('div', {
    staticClass: "topical-container"
  }, [_vm.articles.mobile && _vm.articles.topical ? _c('mobile-section-slider-new-copy', {
    attrs: {
      "code": "topical-articles",
      "name": "Актуально сейчас",
      "items": _vm.articles.topical,
      "no-gray": false,
      "link": "/journal"
    }
  }) : _vm._e()], 1), _vm.articles.mobile && _vm.articles.mobile.lifeHacks.slice(0, 4).length ? _c('mobile-feed', {
    attrs: {
      "code": "lifehacks-mobile",
      "name": "Лайфхаки",
      "items": _vm.articles.mobile.lifeHacks.slice(0, 4),
      "link": "/category/lifehacks"
    }
  }) : _vm._e(), _vm.articles.mobile && _vm.articles.mobile.knowledge.slice(0, 4).length ? _c('mobile-feed', {
    attrs: {
      "code": "knowledge-mobile",
      "name": "Знания",
      "items": _vm.articles.mobile.knowledge.slice(0, 4),
      "link": "/category/knowledge"
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "phone"
  }, [_c('InvestBanner')], 1), _c('div', {
    staticClass: "container phone new-main-feed"
  }, [_vm.articles.mobile && _vm.articles.mobile.test.slice(0, 4).length ? _c('mobile-feed', {
    attrs: {
      "code": "tests-mobile",
      "name": "Тесты",
      "items": _vm.articles.mobile.test.slice(0, 4),
      "link": "/category/test"
    }
  }) : _vm._e(), _vm.articles.mobile && _vm.articles.mobile.reviews.slice(0, 4).length ? _c('mobile-feed', {
    attrs: {
      "code": "reviews-mobile",
      "name": "Ревью",
      "items": _vm.articles.mobile.reviews.slice(0, 4),
      "link": "/category/reviews"
    }
  }) : _vm._e()], 1)] : _vm._e(), _vm.category || _vm.isJournal ? [_vm.articles.desktop ? _c('div', {
    staticClass: "container pc journal"
  }, [_c('div', {
    staticClass: "journal-section-btns"
  }, [_c('button', {
    class: {
      active: _vm.category === null
    },
    on: {
      "click": function click($event) {
        return _vm.setCategory(null);
      }
    }
  }, [_vm._v("Все")]), _c('button', {
    class: {
      active: _vm.category === 'lifehacks'
    },
    on: {
      "click": function click($event) {
        return _vm.setCategory('lifehacks');
      }
    }
  }, [_vm._v("Лайфхаки")]), _c('button', {
    class: {
      active: _vm.category === 'knowledge'
    },
    on: {
      "click": function click($event) {
        return _vm.setCategory('knowledge');
      }
    }
  }, [_vm._v("Знания")]), _c('button', {
    class: {
      active: _vm.category === 'test'
    },
    on: {
      "click": function click($event) {
        return _vm.setCategory('test');
      }
    }
  }, [_vm._v("Тесты")]), _c('button', {
    class: {
      active: _vm.category === 'reviews'
    },
    on: {
      "click": function click($event) {
        return _vm.setCategory('reviews');
      }
    }
  }, [_vm._v("Ревью")])]), _vm.category ? [_vm._l(_vm.currentPage * 3, function (n) {
    return [_vm.articles.desktop[n] ? [_vm.articles.desktop[n] ? _c('cards-section', {
      key: 'journal-rows_' + n,
      attrs: {
        "code": _vm.category,
        "items": _vm.articles.desktop[n]
      }
    }) : _vm._e()] : _vm._e()];
  }), _c('div', {
    directives: [{
      name: "observe-visibility",
      rawName: "v-observe-visibility",
      value: _vm.handleScrolledToBottom,
      expression: "handleScrolledToBottom"
    }]
  }), _vm.showLoader ? _c('div', {
    staticClass: "loader-wrapper"
  }, [_c('img', {
    staticClass: "circle-loader",
    attrs: {
      "src": require("@/assets/img/circle-loader.svg")
    }
  })]) : _vm._e()] : [_vm._l(_vm.currentPage * 3, function (n) {
    return [_vm.articles.desktop.all ? [_vm.articles.desktop.all[n] ? _c('cards-section', {
      key: 'journal-rows_' + n,
      attrs: {
        "items": _vm.articles.desktop.all[n]
      }
    }) : _vm._e()] : _vm._e()];
  }), _c('div', {
    directives: [{
      name: "observe-visibility",
      rawName: "v-observe-visibility",
      value: _vm.handleScrolledToBottom,
      expression: "handleScrolledToBottom"
    }]
  }), _vm.showLoader ? _c('div', {
    staticClass: "loader-wrapper"
  }, [_c('img', {
    staticClass: "circle-loader",
    attrs: {
      "src": require("@/assets/img/circle-loader.svg")
    }
  })]) : _vm._e()]], 2) : _vm._e(), _vm.articles.mobile ? _c('div', {
    staticClass: "container-315 phone journal"
  }, [_c('div', {
    staticClass: "journal-section-btns"
  }, [_c('div', [_c('button', {
    class: {
      active: _vm.category === null
    },
    on: {
      "click": function click($event) {
        return _vm.setCategory(null);
      }
    }
  }, [_vm._v("Все")]), _c('button', {
    class: {
      active: _vm.category === 'lifehacks'
    },
    on: {
      "click": function click($event) {
        return _vm.setCategory('lifehacks');
      }
    }
  }, [_vm._v("Лайфхаки")]), _c('button', {
    class: {
      active: _vm.category === 'knowledge'
    },
    on: {
      "click": function click($event) {
        return _vm.setCategory('knowledge');
      }
    }
  }, [_vm._v("Знания")]), _c('button', {
    class: {
      active: _vm.category === 'test'
    },
    on: {
      "click": function click($event) {
        return _vm.setCategory('test');
      }
    }
  }, [_vm._v("Тесты")]), _c('button', {
    class: {
      active: _vm.category === 'reviews'
    },
    on: {
      "click": function click($event) {
        return _vm.setCategory('reviews');
      }
    }
  }, [_vm._v("Ревью")])])]), _c('div', {
    staticClass: "journal-feed-wrapper"
  }, [_vm.category ? [_vm._l(_vm.currentPage * 4, function (n) {
    return [_vm.articles.mobile[n] ? [_vm.articles.mobile[n] ? _c('div', {
      key: 'extra-mobile-card' + n
    }, [_vm.articles.mobile[n] ? _c('ArticleCardMobile', {
      attrs: {
        "article": _vm.articles.mobile[n]
      }
    }) : _vm._e()], 1) : _vm._e()] : _vm._e()];
  }), _c('div', {
    directives: [{
      name: "observe-visibility",
      rawName: "v-observe-visibility",
      value: _vm.handleScrolledToBottom,
      expression: "handleScrolledToBottom"
    }]
  }), _vm.showLoader ? _c('div', {
    staticClass: "loader-wrapper"
  }, [_c('img', {
    staticClass: "circle-loader",
    attrs: {
      "src": require("@/assets/img/circle-loader.svg")
    }
  })]) : _vm._e()] : [_vm._l(_vm.currentPage * 4, function (n) {
    return [_vm.articles.mobile.all ? [_vm.articles.mobile.all[n] ? _c('div', {
      key: 'extra-all-mobile-card' + n
    }, [_vm.articles.mobile.all[n] ? _c('ArticleCardMobile', {
      attrs: {
        "article": _vm.articles.mobile.all[n]
      }
    }) : _vm._e()], 1) : _vm._e()] : _vm._e()];
  }), _c('div', {
    directives: [{
      name: "observe-visibility",
      rawName: "v-observe-visibility",
      value: _vm.handleScrolledToBottom,
      expression: "handleScrolledToBottom"
    }]
  }), _vm.showLoader ? _c('div', {
    staticClass: "loader-wrapper"
  }, [_c('img', {
    staticClass: "circle-loader",
    attrs: {
      "src": require("@/assets/img/circle-loader.svg")
    }
  })]) : _vm._e()]], 2)]) : _vm._e()] : _vm._e(), _c('SocialBanner'), _c('Footer')] : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }